import styled from 'styled-components';

import variables from '../../styles/variables';
import Input from '../elements/Input/Input';
import searhIcon from '../../images/search-icon.svg';

export const StoreLocationSection = styled.section<{desktopImage?: string, tabletImage?: string, mobileImage?: string, showSearch?: boolean}>`
  background-image: ${(props) => `url(${props.desktopImage})`};
  background-repeat: no-repeat;
  background-position: center bottom;
  padding-top: ${(props) => props.showSearch ? 'clamp(100px, 7vw, 200px)' : '50px'};
  padding-bottom: clamp(100px, 7vw, 200px);
  margin-bottom: max(-400px, -4vw);
  background-size: cover;

  @media screen and (max-width: 1100px) {
    background-size: cover;
  }
  @media screen and (max-width: 681px) {
    background-image: ${(props) => `url(${props.tabletImage})`};
  }
  @media screen and (max-width: 480px) {
    background-size: 95% 80%;
    background-image: ${(props) => `url(${props.mobileImage})`};
  }
`;

export const SectionHeading = styled.div`
  color: ${variables.colorRed};
  font-size: 37px;
  text-align: center;
  width: 56%;
  line-height: 38px;
  margin: 0 auto;
  font-weight: bold;
  word-spacing: 3px;
  @media screen and (max-width: 1167px) {
    width: 80%;
  }
  @media screen and (max-width: 662px) {
    width: 56%;
    font-size: 29px;
    word-spacing: normal;
  }
  @media screen and (max-width: 540px) {
    width: 95%;
    font-size: 26px;
  }
`;

export const InputFieldWrapper = styled.div`
  width: 562px;
  margin: 55px auto;
  display: grid;
  grid-template-columns: 1fr 18px;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 767px) {
    margin: 0 auto;
    margin-top: 61px;
    text-align: center;
  }
  @media screen and (max-width: 640px) {
    width: 327px;
    margin-top: 28px;
  }
  @media screen and (max-width: 375px) {
    width: 100%;
    padding: 0px 8px;
  }
`;

export const InputField = styled(Input)`
  grid-column: 1 / 3;
  grid-row-start: 1;
  text-align: left;
  height: 40px;
  font-size: 14px;
  border-radius: 20px;
  width: 100%;
  margin: 0 auto;
  padding: 0 100px 0 40px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 0.5px #6b6b6b;
  background-color: ${variables.colorWhite};
  border: grey solid 1px;
  background-image: url(${searhIcon});
  background-repeat: no-repeat;
  background-position: 1rem center;
  background-size: auto;

  @media screen and (max-width: 400px) {
    font-size: 3.75vw;
  }
`;

export const CTAButton = styled.button`
  grid-column: 1 / 2;
  grid-row-start: 1;
  justify-self: end;
  display: flex;
  align-items: center;
  text-align: center;
  height: 30px;
  font-size: 12px;
  color: ${variables.colorWhite};
  background: ${variables.colorBlack};
  padding: 9px 16px;
  border-radius: 15px;
  border: none;
  cursor: pointer;
`;

export const LogoWrapper = styled.div`
  align-items: center;
  display: flex;
  width: 83%;
  max-width: 880px;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: center;
  @media screen and (max-width: 1150px) {
    width: 100%;
  }
`;
export const LogoDiv = styled.div`
  width: 25%;
  padding: 1rem;
  @media screen and (max-width: 767px) {
    width: 50%;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  max-width: 190px;
  margin: auto;

  @media screen and (max-width: 950px) {
    height: 30px;
  }
  @media screen and (max-width: 767px) {
    height: 35px;
  }
  @media screen and (max-width: 390px) {
    height: 30px;
  }

  img {
    width: 100%;
    height: 100%;
  }
`;

export const CtaContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;

  @media screen and (max-width: 767px) {
    margin-top: 32px;
  }
`;
